module.exports = __webpack_public_path__ + "img/camara.98c6f3b5.svg";